<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="취소 요청 내역"
      desc=""
    ></admin-filter>

    <!-- 탭 2 -->
    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 nextPageName="nopage"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="checkArr[props.idx]!==undefined"
          :checkedVal.sync="checkArr[props.idx].value"></lp-check-bool>
      </div>

      <!-- 번호 -->
      <div slot="index" slot-scope="props">{{ props.item.index }}</div>

      <!-- 상품 주문번호 -->
      <div slot="order_num" slot-scope="props">
        <div @click="clickDetail(props.item.order)"
             class="unselect"
             style="text-decoration: underline">{{ props.item.order.order_num }}</div>
      </div>

      <!-- 날짜 -->
      <div slot="created_time" slot-scope="props">{{ props.item.created_time }}</div>

      <!-- 주문자 -->
      <div slot="order"
           slot-scope="props"
           :rowspan="props.item.rowspan"
           v-if="!props.item.is_duplicate">{{ props.item.order.name }}</div>

      <!-- 주문 상품 -->
      <div slot="product" slot-scope="props">
        <div style="text-align: left">
          <div>{{ props.item.product.name }}</div>
          <div v-for="(op, idx) in props.item.option"
               :key="`option-${idx}`">
            <div>옵션: {{ op.name }} / {{ op.price | currency }}</div>
          </div>

        </div>
      </div>

      <!-- 수량 -->
      <div slot="quantity" slot-scope="props">{{ props.item.quantity }}</div>

      <!-- 총 상품 금액-->
      <div slot="product_price" slot-scope="props">{{ props.item.product_price | currency }}</div>

      <!-- 할인 금액 -->
      <div slot="discount_price" slot-scope="props">{{ props.item.discount_price | currency }}</div>

      <!-- 전체 금액-->
      <div slot="total_price" slot-scope="props" :rowspan="props.item.rowspan" v-if="!props.item.is_duplicate">{{ totalPrice(props.item) | currency }}</div>

      <!-- 파트너명 -->
      <div slot="partner" slot-scope="props">{{ props.item.partner }}</div>

      <!-- 주문 상태 -->
      <div slot="status" slot-scope="props">{{ orderStatus(props.item.status) }}</div>

      <!-- 결제 상태 -->
      <div slot="pay_status" slot-scope="props">{{ payStatus(props.item.status )}}</div>

      <!-- 결제 방법 -->
      <div slot="pay_type" slot-scope="props">{{ props.item.pay_type }}</div>
    </admin-table>

    <modal name="cancelModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="삭제" :useTab="false" class="lp-modal-wrapper">
        <div>결제취소 처리하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelModal')">취소</button>
          <button class="button is-primary" @click="confirmModal(501)">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../../module/common/LpCheckBool";
  import Const from "../../../../../utils/const"
  import CommerceMixin from "@/mixins/CommerceMixin"

  export default {
    name: 'PurchaseCancelAll',
    components: {LpCheckBool},
    mixins: [
      CommerceMixin
    ],
    data() {
      return {}
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('order', 'commerce/orderproduct?start_status=500&end_status=501', 'OrderCancelAll');
      },
      getDataFromServer() {
        this.getData();
      },
      totalPrice(item) {
        let total_price = 0;
        for(let i=0; i<this.tableItems.length; i++){
          if(this.tableItems[i].order === item.order) {
            total_price += this.tableItems[i].total_price;
          }
        }
        return total_price;
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
</style>
